"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("../classnames"));
var SubnavItem = function (_a) {
    var active = _a.active, children = _a.children, className = _a.className, onClick = _a.onClick;
    return (react_1.default.createElement("button", { role: "tab", type: "button", "aria-current": active, "aria-selected": active, className: classnames_1.default("chq-snv--it", className), onClick: onClick }, children));
};
var Subnav = /** @class */ (function (_super) {
    __extends(Subnav, _super);
    function Subnav(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { activeIndex: props.activeIndex || 0 };
        return _this;
    }
    Subnav.prototype.componentDidUpdate = function (prevProps, prevState) {
        var onChange = this.props.onChange;
        var activeIndex = this.state.activeIndex;
        if (onChange && (prevState.activeIndex !== activeIndex)) {
            onChange(activeIndex);
        }
    };
    Subnav.prototype.render = function () {
        var _this = this;
        var _a = this.props, children = _a.children, className = _a.className, givenIndex = _a.activeIndex, ariaLabel = _a.ariaLabel;
        var currentIndex = this.state.activeIndex;
        var activeIndex = typeof givenIndex === "number" ? givenIndex : currentIndex;
        return (react_1.default.createElement("div", { role: "tablist", "aria-label": ariaLabel, className: classnames_1.default(className, "chq-snv") }, react_1.default.Children.map(children, function (child, index) { return (react_1.default.cloneElement(child, {
            active: index === activeIndex,
            onClick: function () { return _this.setState({ activeIndex: index }); }
        })); })));
    };
    Subnav.Item = SubnavItem;
    return Subnav;
}(react_1.default.Component));
exports.default = Subnav;
